module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/media/personality-relax-riben.334efdcd.mp4";